import script from "./DashBordView.vue?vue&type=script&setup=true&lang=js"
export * from "./DashBordView.vue?vue&type=script&setup=true&lang=js"

import "./DashBordView.vue?vue&type=style&index=0&id=d32b27de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d32b27de"]])

export default __exports__